// Ejemplos: dispositivos de entrada y sensores I²C.
import { at, part, wires, UNO } from './helpers.js';

const BB = { id: 'bb1', type: 'breadboard', x: 0, z: 80, rot: 0, props: { size: 'half' } };

export const EXAMPLES = [
  {
    id: 'joystick',
    category: 'Entradas',
    name: 'Joystick: ejes y botón',
    description: 'Lee los dos ejes del joystick KY-023 (A0 y A1) y su botón (pin 2). Arrastra la palanca en 3D y mira la pestaña «Gráfica».',
    project: {
      name: 'Joystick',
      files: {
        'sketch.ino': `// Joystick KY-023: lee los dos ejes (A0 y A1) y el botón SW (pin 2).
// Arrastra la palanca en la vista 3D (vuelve sola al centro); un clic sin arrastrar la hunde.
// Abre la pestaña «Gráfica» para ver las tres señales.

const int PIN_X = A0;
const int PIN_Y = A1;
const int PIN_SW = 2;

void setup() {
  Serial.begin(9600);
  pinMode(PIN_SW, INPUT_PULLUP);   // el módulo no trae resistencia de pull-up en SW
}

void loop() {
  int x = analogRead(PIN_X);       // de 0 a 1023; en el centro ≈ 512
  int y = analogRead(PIN_Y);
  bool boton = digitalRead(PIN_SW) == LOW;

  Serial.print("X:");
  Serial.print(x);
  Serial.print(" Y:");
  Serial.print(y);
  Serial.print(" Boton:");
  Serial.println(boton ? 1023 : 0);
  delay(50);
}
`,
      },
      parts: [UNO, part('joy1', 'joystick', {}, { x: 86, z: 26, rot: 0 })],
      wires: wires([
        ['joy1:GND', 'uno:GND.2', 'black'],
        ['joy1:+5V', 'uno:5V', 'red'],
        ['joy1:VRx', 'uno:A0', 'orange'],
        ['joy1:VRy', 'uno:A1', 'yellow'],
        ['joy1:SW', 'uno:2', 'green'],
      ]),
    },
  },
  {
    id: 'encoder-rotatorio',
    category: 'Entradas',
    name: 'Encoder rotatorio: contador',
    description: 'Cuenta los pasos del encoder KY-040 y el sentido de giro leyendo CLK y DT; el botón vuelve el contador a cero.',
    project: {
      name: 'Encoder rotatorio',
      files: {
        'sketch.ino': `// Encoder rotatorio KY-040: cuenta los pasos y detecta el sentido de giro.
// En la vista 3D usa la rueda del mouse sobre la perilla para girarla y haz clic para presionarla
// (o usa los botones del panel de la pieza).
// CLK y DT ya tienen resistencias de pull-up en el módulo; SW no, por eso va con INPUT_PULLUP.

const int CLK = 2;
const int DT = 3;
const int SW = 4;

int contador = 0;
int ultimoCLK;
int ultimoSW = HIGH;

void setup() {
  Serial.begin(9600);
  pinMode(CLK, INPUT);
  pinMode(DT, INPUT);
  pinMode(SW, INPUT_PULLUP);
  ultimoCLK = digitalRead(CLK);
  Serial.println("Gira la perilla");
}

void loop() {
  int clk = digitalRead(CLK);
  // Cada paso empieza con un flanco de bajada en CLK. Si en ese momento DT sigue en alto,
  // CLK cambió primero: el giro es horario. Si DT ya bajó, es antihorario.
  if (clk != ultimoCLK && clk == LOW) {
    if (digitalRead(DT) == HIGH) {
      contador++;
      Serial.print("Horario      ");
    } else {
      contador--;
      Serial.print("Antihorario  ");
    }
    Serial.print("contador = ");
    Serial.println(contador);
  }
  ultimoCLK = clk;

  int sw = digitalRead(SW);
  if (sw == LOW && ultimoSW == HIGH) {   // se acaba de presionar
    contador = 0;
    Serial.println("Botón: contador en 0");
  }
  ultimoSW = sw;
}
`,
      },
      parts: [UNO, part('enc1', 'rotary-encoder', {}, { x: 82, z: -22, rot: 0 })],
      wires: wires([
        ['enc1:CLK', 'uno:2', 'yellow'],
        ['enc1:DT', 'uno:3', 'green'],
        ['enc1:SW', 'uno:4', 'blue'],
        ['enc1:+', 'uno:5V', 'red'],
        ['enc1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'teclado-clave',
    category: 'Entradas',
    name: 'Teclado 4×4: clave de acceso',
    description: 'Con la librería Keypad: escribe la clave (1234) y presiona # para «abrir»; el LED L se enciende si es correcta.',
    project: {
      name: 'Teclado con clave',
      files: {
        'sketch.ino': `// Teclado de membrana 4×4 con la librería Keypad: clave de acceso.
// Haz clic en las teclas del modelo 3D (o en los botones del panel de la pieza).
// Escribe 1234 y presiona # para abrir; * borra lo escrito.
#include <Keypad.h>

const byte FILAS = 4;
const byte COLUMNAS = 4;
char teclas[FILAS][COLUMNAS] = {
  {'1', '2', '3', 'A'},
  {'4', '5', '6', 'B'},
  {'7', '8', '9', 'C'},
  {'*', '0', '#', 'D'},
};
byte pinesFilas[FILAS] = {9, 8, 7, 6};         // R1–R4
byte pinesColumnas[COLUMNAS] = {5, 4, 3, 2};   // C1–C4

Keypad teclado = Keypad(makeKeymap(teclas), pinesFilas, pinesColumnas, FILAS, COLUMNAS);

const char CLAVE[] = "1234";
char escrito[9];
byte cuantos = 0;

void setup() {
  Serial.begin(9600);
  pinMode(LED_BUILTIN, OUTPUT);
  Serial.println("Escribe la clave y presiona #");
}

void loop() {
  char tecla = teclado.getKey();
  if (!tecla) return;

  if (tecla == '#') {
    escrito[cuantos] = '\\0';
    bool ok = strcmp(escrito, CLAVE) == 0;
    Serial.println(ok ? "  -> Clave correcta: abierto" : "  -> Clave incorrecta");
    digitalWrite(LED_BUILTIN, ok ? HIGH : LOW);
    cuantos = 0;
  } else if (tecla == '*') {
    cuantos = 0;
    Serial.println("  (borrado)");
  } else if (cuantos < 8) {
    escrito[cuantos++] = tecla;
    Serial.print('*');                // no muestra la clave
  }
}
`,
      },
      parts: [UNO, part('kp1', 'keypad', {}, { x: 17, z: -160, rot: 0 })],
      wires: wires([
        ['kp1:R1', 'uno:9', 'orange'],
        ['kp1:R2', 'uno:8', 'orange'],
        ['kp1:R3', 'uno:7', 'orange'],
        ['kp1:R4', 'uno:6', 'orange'],
        ['kp1:C1', 'uno:5', 'blue'],
        ['kp1:C2', 'uno:4', 'blue'],
        ['kp1:C3', 'uno:3', 'blue'],
        ['kp1:C4', 'uno:2', 'blue'],
      ]),
    },
  },
  {
    id: 'control-remoto-ir',
    category: 'Entradas',
    name: 'Control remoto infrarrojo',
    description: 'El receptor VS1838B y la librería IRremote decodifican las teclas del control (protocolo NEC): + y − cambian el brillo de un LED, ⏯ lo apaga.',
    project: {
      name: 'Control remoto IR',
      files: {
        'sketch.ino': `// Control remoto infrarrojo con la librería IRremote (protocolo NEC, dirección 0x00).
// Haz clic en las teclas del control en la vista 3D (o en los botones del panel de la pieza).
// + y − cambian el brillo del LED del pin 9 y ⏯ lo enciende o lo apaga.
#include <IRremote.hpp>

const int PIN_IR = 2;
const int PIN_LED = 9;   // IRremote usa el Timer2: no uses los pines 3 ni 11 con analogWrite

int brillo = 128;
bool encendido = true;

const char *nombre(uint8_t codigo) {
  switch (codigo) {
    case 0x45: return "CH-";
    case 0x46: return "CH";
    case 0x47: return "CH+";
    case 0x44: return "Anterior";
    case 0x40: return "Siguiente";
    case 0x43: return "Reproducir/Pausa";
    case 0x07: return "-";
    case 0x15: return "+";
    case 0x09: return "EQ";
    case 0x16: return "0";
    case 0x19: return "100+";
    case 0x0D: return "200+";
    case 0x0C: return "1";
    case 0x18: return "2";
    case 0x5E: return "3";
    case 0x08: return "4";
    case 0x1C: return "5";
    case 0x5A: return "6";
    case 0x42: return "7";
    case 0x52: return "8";
    case 0x4A: return "9";
    default: return "?";
  }
}

void setup() {
  Serial.begin(9600);
  IrReceiver.begin(PIN_IR, ENABLE_LED_FEEDBACK);   // el LED L parpadea con cada trama
  pinMode(PIN_LED, OUTPUT);
  analogWrite(PIN_LED, brillo);
  Serial.println("Presiona una tecla del control");
}

void loop() {
  if (!IrReceiver.decode()) return;
  uint8_t codigo = IrReceiver.decodedIRData.command;
  bool repeticion = IrReceiver.decodedIRData.flags & IRDATA_FLAGS_IS_REPEAT;
  IrReceiver.resume();                              // listo para la siguiente trama

  Serial.print("Tecla ");
  Serial.print(nombre(codigo));
  Serial.print("  (0x");
  Serial.print(codigo, HEX);
  Serial.println(repeticion ? ", repetición)" : ")");

  if (codigo == 0x15) brillo = min(255, brillo + 16);
  else if (codigo == 0x07) brillo = max(0, brillo - 16);
  else if (codigo == 0x43 && !repeticion) encendido = !encendido;
  analogWrite(PIN_LED, encendido ? brillo : 0);
}
`,
      },
      parts: [
        UNO,
        BB,
        part('ir1', 'ir-receiver', {}, at(BB, 'j19', 'ir-receiver')),
        part('led1', 'led', { color: 'green' }, at(BB, 'e6', 'led')),
        part('r1', 'resistor', { value: 220 }, at(BB, 'a7', 'resistor')),
      ],
      wires: wires([
        ['uno:5V', 'bb1:tp1', 'red'],
        ['uno:GND.2', 'bb1:tn1', 'black'],
        ['bb1:f19', 'uno:2', 'yellow'],
        ['bb1:f20', 'bb1:tn16', 'black'],
        ['bb1:f21', 'bb1:tp18', 'red'],
        ['bb1:c11', 'uno:9', 'green'],
        ['bb1:b6', 'bb1:tn5', 'black'],
      ]),
    },
  },
  {
    id: 'mpu6050-inclinacion',
    category: 'Sensores',
    name: 'Acelerómetro MPU-6050: inclinación',
    description: 'Con Adafruit_MPU6050 lee aceleración, giro y temperatura del GY-521 por I²C y calcula la inclinación. Mueve los deslizadores de la pieza.',
    project: {
      name: 'MPU-6050',
      files: {
        'sketch.ino': `// MPU-6050 (módulo GY-521) con la librería Adafruit_MPU6050: aceleración, giro y temperatura.
// La inclinación (cabeceo y alabeo) sale de la dirección de la gravedad.
// Mueve los deslizadores de la pieza (aceleración en g, giro en °/s) y mira la pestaña «Gráfica».
#include <Adafruit_MPU6050.h>
#include <Adafruit_Sensor.h>
#include <Wire.h>

Adafruit_MPU6050 mpu;

void setup() {
  Serial.begin(115200);
  if (!mpu.begin()) {                       // dirección 0x68 (AD0 a GND)
    Serial.println("No encuentro el MPU-6050: revisa SDA (A4) y SCL (A5)");
    while (true) delay(10);
  }
  mpu.setAccelerometerRange(MPU6050_RANGE_4_G);
  mpu.setGyroRange(MPU6050_RANGE_500_DEG);
  mpu.setFilterBandwidth(MPU6050_BAND_21_HZ);
  Serial.println("MPU-6050 listo");
}

void loop() {
  sensors_event_t a, g, temp;
  mpu.getEvent(&a, &g, &temp);              // aceleración en m/s², giro en rad/s

  float ax = a.acceleration.x, ay = a.acceleration.y, az = a.acceleration.z;
  float cabeceo = atan2(-ax, sqrt(ay * ay + az * az)) * 180 / PI;
  float alabeo = atan2(ay, az) * 180 / PI;

  Serial.print("Cabeceo:");
  Serial.print(cabeceo, 1);
  Serial.print(" Alabeo:");
  Serial.print(alabeo, 1);
  Serial.print(" GiroZ:");
  Serial.print(g.gyro.z * 180 / PI, 1);     // rad/s → °/s
  Serial.print(" Temp:");
  Serial.println(temp.temperature, 1);
  delay(100);
}
`,
      },
      parts: [UNO, BB, part('mpu1', 'mpu6050', { ax: 0.26, ay: -0.17, az: 0.95 }, at(BB, 'f10', 'mpu6050'))],
      wires: wires([
        ['bb1:h10', 'uno:5V', 'red'],
        ['bb1:h11', 'uno:GND.2', 'black'],
        ['bb1:h12', 'uno:A5', 'yellow'],
        ['bb1:h13', 'uno:A4', 'blue'],
      ]),
    },
  },
  {
    id: 'reloj-ds1307',
    category: 'Sensores',
    name: 'Reloj DS1307 (Tiny RTC)',
    description: 'Con RTClib muestra la fecha y la hora cada segundo; escribe una fecha en el monitor serie para ponerlo en hora.',
    project: {
      name: 'Reloj DS1307',
      files: {
        'sketch.ino': `// Reloj de tiempo real DS1307 (módulo Tiny RTC) con la librería RTClib.
// Con la pila puesta el reloj ya está en hora (la de tu computadora al iniciar la simulación).
// Para cambiarla escribe en el monitor serie, por ejemplo: 2030-12-31 23:59:50
#include <RTClib.h>

RTC_DS1307 rtc;
const char *DIAS[] = {"domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"};

void setup() {
  Serial.begin(9600);
  if (!rtc.begin()) {
    Serial.println("No encuentro el DS1307: revisa SDA (A4), SCL (A5) y que tenga 5 V");
    while (true);
  }
  if (!rtc.isrunning()) {           // sin pila arranca detenido
    Serial.println("El reloj estaba detenido: lo pongo con la hora de compilación");
    rtc.adjust(DateTime(F(__DATE__), F(__TIME__)));
  }
}

void loop() {
  if (Serial.available()) {         // AAAA-MM-DD HH:MM:SS
    String s = Serial.readStringUntil('\\n');
    int a, me, d, h, mi, se;
    if (sscanf(s.c_str(), "%d-%d-%d %d:%d:%d", &a, &me, &d, &h, &mi, &se) == 6) {
      rtc.adjust(DateTime(a, me, d, h, mi, se));
      Serial.println("Reloj ajustado");
    }
  }

  static int ultimo = -1;
  DateTime t = rtc.now();
  if (t.second() == ultimo) return; // solo cuando cambia el segundo
  ultimo = t.second();

  char texto[48];
  snprintf(texto, sizeof(texto), "%s %02d/%02d/%04d  %02d:%02d:%02d", DIAS[t.dayOfTheWeek()],
           t.day(), t.month(), t.year(), t.hour(), t.minute(), t.second());
  Serial.println(texto);
  delay(50);
}
`,
      },
      parts: [UNO, part('rtc1', 'ds1307', {}, { x: 72, z: 22, rot: 0 })],
      wires: wires([
        ['rtc1:GND', 'uno:GND.2', 'black'],
        ['rtc1:VCC', 'uno:5V', 'red'],
        ['rtc1:SDA', 'uno:A4', 'blue'],
        ['rtc1:SCL', 'uno:A5', 'yellow'],
      ]),
    },
  },
  {
    id: 'reloj-ds3231-lcd',
    category: 'Sensores',
    name: 'Reloj DS3231 con pantalla LCD',
    description: 'Fecha, hora y temperatura del DS3231 en una LCD I²C conectada al conector de paso del módulo ZS-042 (comparten el bus I²C).',
    project: {
      name: 'Reloj DS3231 con LCD',
      files: {
        'sketch.ino': `// Reloj DS3231 (módulo ZS-042) con pantalla LCD 16x2 I²C: fecha, hora y temperatura.
// La LCD va en el conector de paso del módulo: las dos piezas comparten el bus I²C
// (DS3231 en 0x68, su EEPROM en 0x57 y la LCD en 0x27).
#include <RTClib.h>
#include <LiquidCrystal_I2C.h>

RTC_DS3231 rtc;
LiquidCrystal_I2C lcd(0x27, 16, 2);
const char *DIAS[] = {"Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"};

void setup() {
  lcd.init();
  lcd.backlight();
  if (!rtc.begin()) {
    lcd.print("Sin DS3231");
    while (true);
  }
  if (rtc.lostPower()) {            // sin pila se pierde la hora
    rtc.adjust(DateTime(F(__DATE__), F(__TIME__)));
  }
}

void loop() {
  DateTime t = rtc.now();
  char linea[17];
  snprintf(linea, sizeof(linea), "%s %02d/%02d/%04d", DIAS[t.dayOfTheWeek()], t.day(), t.month(), t.year());
  lcd.setCursor(0, 0);
  lcd.print(linea);
  snprintf(linea, sizeof(linea), "%02d:%02d:%02d ", t.hour(), t.minute(), t.second());
  lcd.setCursor(0, 1);
  lcd.print(linea);
  lcd.print(rtc.getTemperature(), 1);   // se actualiza cada 64 s
  lcd.print((char)223);                  // símbolo de grados de la ROM del HD44780
  lcd.print("C ");
  delay(200);
}
`,
      },
      parts: [
        UNO,
        part('rtc1', 'ds3231', { temperature: 23.5 }, { x: 80, z: 30, rot: 0 }),
        part('lcd1', 'lcd-i2c', { size: '16x2', color: 'blue' }, { x: 160, z: 40, rot: 0 }),
      ],
      wires: wires([
        ['rtc1:GND', 'uno:GND.2', 'black'],
        ['rtc1:VCC', 'uno:5V', 'red'],
        ['rtc1:SDA', 'uno:A4', 'blue'],
        ['rtc1:SCL', 'uno:A5', 'yellow'],
        ['rtc1:GND.2', 'lcd1:GND', 'black'],
        ['rtc1:VCC.2', 'lcd1:VCC', 'red'],
        ['rtc1:SDA.2', 'lcd1:SDA', 'blue'],
        ['rtc1:SCL.2', 'lcd1:SCL', 'yellow'],
      ]),
    },
  },
  {
    id: 'bascula-hx711',
    category: 'Sensores',
    name: 'Báscula con celda de carga (HX711)',
    description: 'Con la librería HX711: tara al arrancar y muestra los gramos; mueve «Peso sobre la celda» en el panel de la pieza.',
    project: {
      name: 'Báscula HX711',
      files: {
        'sketch.ino': `// Báscula con celda de carga de 1 kg y el convertidor HX711 («HX711 Arduino Library»).
// Con ganancia 128 la celda de 1 kg da ≈ 2147.5 cuentas por gramo: ese es el factor de escala.
// Mueve «Peso sobre la celda» en el panel de la pieza. Escribe t en el monitor serie para la tara.
#include "HX711.h"

const int PIN_DT = A1;
const int PIN_SCK = A0;
const float FACTOR = 2147.48;     // cuentas por gramo (celda de 1 kg)

HX711 bascula;

void setup() {
  Serial.begin(9600);
  bascula.begin(PIN_DT, PIN_SCK);
  Serial.print("Lectura cruda sin peso: ");
  Serial.println(bascula.read());
  bascula.set_scale(FACTOR);
  bascula.tare(10);               // el peso actual queda como cero
  Serial.println("Listo: pon algo sobre la celda");
}

void loop() {
  if (Serial.available() && Serial.read() == 't') {
    bascula.tare(10);
    Serial.println("Tara hecha");
  }
  Serial.print("Gramos:");
  Serial.println(bascula.get_units(5), 1);   // promedio de 5 lecturas (medio segundo)
}
`,
      },
      parts: [UNO, part('hx1', 'hx711', { capacity: 1000, weight: 0 }, { x: -22, z: 78, rot: 0 })],
      wires: wires([
        ['hx1:GND', 'uno:GND.2', 'black'],
        ['hx1:VCC', 'uno:5V', 'red'],
        ['hx1:DT', 'uno:A1', 'green'],
        ['hx1:SCK', 'uno:A0', 'yellow'],
      ]),
    },
  },
];
